import {
  isFullSuperAdminProfileType,
  isSuperAdminLimitedProfileType,
  isSuperAdminProfileType,
} from '@/features/currentUser/constants'

export function unwrapMyDetails(myDetails) {
  return myDetails?.value ?? myDetails ?? null
}

export function normalizeTenantForPermission(tenant) {
  if (!tenant) return null

  return {
    tenantId: tenant.tenantId,
    tenantintId: tenant.tenantintId,
    name: tenant.name,
    hasOsiAccess: tenant.hasOsiAccess,
    hasMobileAccess: tenant.hasMobileAccess,
    roleGroups: tenant.roleGroups ?? tenant.tenantRights?.roleGroups ?? [],
    source: tenant.source ?? tenant,
  }
}

export function normalizeActorFromMyDetails(myDetails) {
  const value = unwrapMyDetails(myDetails)

  if (!value) {
    return {
      kind: 'anonymous',
      isAuthenticated: false,
      isSuperAdmin: false,
      tenants: [],
    }
  }

  const isSuperAdmin = isSuperAdminProfileType(value.type)
  const isFullSuperAdmin = isFullSuperAdminProfileType(value.type)
  const isSuperAdminLimited = isSuperAdminLimitedProfileType(value.type)

  return {
    kind: isSuperAdmin ? 'super-admin' : 'tenant-user',
    isAuthenticated: true,
    isSuperAdmin,
    isFullSuperAdmin,
    isSuperAdminLimited,
    profileId: value.profileId,
    appUserId: value.appUserId,
    appUserintId: value.appUserintId,
    type: value.type,
    typeString: value.typeString,
    tenants: (value.myTenants ?? []).map(normalizeTenantForPermission),
    superAdminLimitedRoleGroups: value.superAdminLimitedRights?.roleGroups ?? [],
  }
}

export function getTenantRoleEvidence(tenant) {
  const roleGroups = tenant?.roleGroups ?? tenant?.tenantRights?.roleGroups ?? []
  const roleNames = roleGroups.flatMap(roleGroup =>
    (roleGroup.roles ?? []).map(role => role.name).filter(Boolean),
  )

  return {
    roleGroups: roleGroups.map(roleGroup => roleGroup.name).filter(Boolean),
    roleNames,
  }
}

export function getSuperAdminLimitedRoleEvidence(actor) {
  const roleGroups = actor?.superAdminLimitedRoleGroups ?? []
  const roleNames = roleGroups.flatMap(roleGroup =>
    (roleGroup.roles ?? []).map(role => role.name).filter(Boolean),
  )

  return {
    roleGroups: roleGroups.map(roleGroup => roleGroup.name).filter(Boolean),
    roleNames,
  }
}
